var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactNative = require("react-native");
var _reactRedux = require("react-redux");
var _store = require("./src/redux/store");
var _Application = _interopRequireDefault(require("./Application"));
var _reactNativePopupMenu = require("react-native-popup-menu");
var _reactNativeSafeAreaContext = require("react-native-safe-area-context");
var _styles = require("@mui/material/styles");
var _jsxRuntime = require("react/jsx-runtime");
var muiTheme = (0, _styles.createTheme)();
var App = function App() {
  return (0, _jsxRuntime.jsx)(_reactNative.View, {
    style: {
      flex: 1,
      alignSelf: 'stretch'
    },
    children: (0, _jsxRuntime.jsx)(_reactRedux.Provider, {
      store: _store.store,
      children: (0, _jsxRuntime.jsx)(_reactNativeSafeAreaContext.SafeAreaProvider, {
        children: (0, _jsxRuntime.jsx)(_styles.ThemeProvider, {
          theme: muiTheme,
          children: (0, _jsxRuntime.jsx)(_reactNativePopupMenu.MenuProvider, {
            children: (0, _jsxRuntime.jsx)(_Application.default, {})
          })
        })
      })
    })
  });
};
var _default = exports.default = App;